export default "__VITE_ASSET__CaS0oI2p__"